module.exports = __webpack_public_path__ + "static/media/diktat-18.d90ea466.mp3";